import { formDataRequest, postRequest } from '../libs/AxiosService.util';

export async function serviceCreateUserQueries(params) {
    return await formDataRequest('support/request/create', params);
}

export async function serviceUpdateUserQueries(params) {
    return await formDataRequest('support/request/update/status', params);
}

export async function serviceGetUserQueries(params) {
    return await postRequest("support/request", params);
}

export async function serviceUserQueriesDetail(params) {
    return await postRequest("support/request/details", params);
}
export async function serviceDeleteUserQueries(params) {
    return await postRequest("support/request/delete", params);
}

export async function serviceUserQueriesIsExist (params) {  
    return await postRequest('support/request/check', params);
}
export async function serviceExportUserQueries (params) {  
    return await postRequest('support/request/export', params);
}
export async function serviceGetConcernList (params) {  
    return await postRequest('support/request/concern/dropdown', params);
}